import React from 'react';

export function usePlayFlag(current: HTMLElement, scollContainer: string) {
  const [playFlag, setPlayFlag] = React.useState(false);
  const calcHeightOfPreviousElements = (currentElement: HTMLElement) => {
    let height = 0;
    let previousElementSibling = currentElement.previousElementSibling;
    while (previousElementSibling !== null) {
      height += (previousElementSibling as HTMLElement)?.offsetHeight;
      previousElementSibling = previousElementSibling.previousElementSibling;
    }
    return height;
  };
  React.useEffect(() => {
    if (current) {
      let height = 0;
      let currentElement: HTMLElement | null = current;
      let parentElement: HTMLElement | null | undefined =
        currentElement?.parentElement;
      do {
        if (currentElement) {
          height += calcHeightOfPreviousElements(currentElement);
          currentElement = currentElement?.parentElement;
          parentElement = currentElement?.parentElement;
        }
      } while (
        currentElement &&
        parentElement &&
        !parentElement?.classList.contains(scollContainer.substr(1))
      );
      const onScroll = () => {
        const scrolltop =
          document.querySelector(scollContainer)?.scrollTop || 0;
        // document?.querySelector('.course-body')?.scrollTop || 0;
        if (scrolltop > height - 300 && !playFlag) {
          setPlayFlag(true);
          document
            .querySelector(scollContainer)
            ?.removeEventListener('scroll', onScroll);
        }
      };
      if (!playFlag) {
        // clean up code
        document
          .querySelector(scollContainer)
          ?.removeEventListener('scroll', onScroll);
        document
          .querySelector(scollContainer)
          ?.addEventListener('scroll', onScroll, { passive: true });
      }
      return () => window.removeEventListener('scroll', onScroll);
    }
  });
  return playFlag;
}
